export const APP_PERMISSIONS = {
  ADMIN_TOOLS: 'admin.tools',
  USERS_READ: 'users.read',
  USERS_MANAGE: 'users.manage',
  MENU_MANAGE: 'menu.manage',
  PERMISSIONS_MANAGE: 'permissions.manage',
  FINANCIALS_VIEW: 'financials.view',
  INVENTORY_MANAGE: 'inventory.manage',
  RATES_MANAGE: 'rates.manage',
  RATE_MANAGER_VIEW: 'glebus_rate_manager_view',
  RATE_MANAGER_EDIT: 'glebus_rate_manager_edit',
  RATE_MANAGER_IMPORT: 'glebus_rate_manager_import',
  RATE_MANAGER_DELETE: 'glebus_rate_manager_delete',
} as const;

export type AppPermission = typeof APP_PERMISSIONS[keyof typeof APP_PERMISSIONS];
